import {
  BaseEquipment,
  Equipment,
  EquipmentCombinations,
} from 'fitbeat.models';

export type EquipmentType = 'bodyweight' | 'dumbbells' | 'benchAndDumbbells' | 'smartHomeGym';

export const getEquipmentList = (equipmentType: EquipmentType): Equipment[] => {
  switch (equipmentType) {
    case 'benchAndDumbbells':
      return BaseEquipment.EquipmentCombinationList[EquipmentCombinations.BENCH_HUB_DUMBBELLS] || [];
    case 'dumbbells':
      return BaseEquipment.EquipmentCombinationList[EquipmentCombinations.DUMBBELLS] || [];
    case 'smartHomeGym':
      return BaseEquipment.EquipmentCombinationList[EquipmentCombinations.BENCH_BANDS] || [];
    case 'bodyweight':
    default:
      return BaseEquipment.EquipmentCombinationList[EquipmentCombinations.BODYWEIGHT] || [];
  }
};
